export const NotFound404 = () => {
    return (
        <div id="main-content">
            <div className="cco_content_area cco_content_area_0">
                <div className="cco_section cco_section_0">
                    <div className="cco_row">
                        <div className="cco_col">
                            <div id="left-area">
                                <article id="post-0" className="et_pb_post not_found">
                                    <div className="entry">
                                        <h1 className="not-found-title">No Results Found</h1>

                                        <p>
                                            The page you requested could not be found. Try refining your search,
                                            or use the navigation above to locate the page.
                                        </p>

                                        {/* Dashboard Button */}
                                        <a
                                            href="/dashboard"
                                            className="cco_button cco_button_primary"
                                        >
                                            ← Go back to Dashboard
                                        </a>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
